import { Injectable, Inject } from '@angular/core';
import { CryptoService } from './crypto.service';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private sk: string;
  private storageSub= new Subject<string>();

  constructor(
    private cryptoService: CryptoService) {
      this.sk = (environment as any).LOCAL ?? '';
  }

  watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }

  public remove(key: string): void {
    const encryptedKey: string = this.cryptoService.encrypt(this.sk, key);
    if (localStorage.getItem(encryptedKey) != null) {
      localStorage.removeItem(encryptedKey);
    }
   
    const encryptedKeyExpiry: string = this.cryptoService.encrypt(this.sk, `${key}_expiry`);
    if (localStorage.getItem(encryptedKeyExpiry) != null) {
      localStorage.removeItem(encryptedKeyExpiry);
    }

    this.storageSub.next('removed');
  }

  public get(key: string ): string | null {
    const encryptedKey: string = this.cryptoService.encrypt(this.sk, key);
    if (localStorage.getItem(encryptedKey) != null) {
      return this.cryptoService.decrypt(this.sk, localStorage.getItem(encryptedKey) || '');
    }
    return null;
  }

  public getEncrypted(key: string): string | null {
    const encryptedKey: string = this.cryptoService.encrypt(this.sk, key);
    return localStorage.getItem(encryptedKey);
  }

  public set(key: string, value: string, expirySeconds?: number): void {
    const encryptedKey: string = this.cryptoService.encrypt(this.sk, key);
    const encryptedValue: string = this.cryptoService.encrypt(this.sk, value);
    localStorage.setItem(encryptedKey, encryptedValue);
    
    if (expirySeconds != undefined && expirySeconds != null) {
      const expiry: number = Date.now() + Math.abs(expirySeconds) * 1000;
      const expiryActual: number = Math.abs(expirySeconds) * 1000;
      const encryptedKeyExpiry: string = this.cryptoService.encrypt(this.sk, `${key}_expiry`);
      const encryptedKeyExpiryActual: string = this.cryptoService.encrypt(this.sk, `${key}_expiry_actual`);
      const encryptedKeyExpiryValue: string = this.cryptoService.encrypt(this.sk, expiry.toString());
      const encryptedKeyExpiryValueActual: string = this.cryptoService.encrypt(this.sk, expiryActual.toString());
      localStorage.setItem(encryptedKeyExpiry, encryptedKeyExpiryValue);
      localStorage.setItem(encryptedKeyExpiryActual, encryptedKeyExpiryValueActual)
    }

    this.storageSub.next('added'); 
  }

  public isExpired(key: string): boolean {
    const encryptedKey: string = this.cryptoService.encrypt(this.sk, `${key}_expiry`);
    if (localStorage.getItem(encryptedKey) != null) {
      return Date.now() > parseInt(this.cryptoService.decrypt(this.sk, localStorage.getItem(encryptedKey)|| ''));
    } 
    return true;
  }

}
